import React, { memo } from 'react';
import { BaseToast } from 'react-native-toast-message';
import type { CustomToastProps } from './CustomToast.types';
import { useToastStyles } from '../../hooks/useToastStyles';
import { Icon, Image, PressableIcon, useStyle } from '../../../../index';

function CustomToast(props: CustomToastProps) {
  const {
    styleOverrides,
    styleOverridesTokens,
    renderLeadingIcon,
    renderTrailingIcon,
    iconProps,
    imageProps,
    trailingIconProps,
    ...rest
  } = props;
  const { baseStyle, successStyle, containerStyle, textStyle } =
    useToastStyles();

  const toastWrapper = useStyle(styleOverridesTokens?.wrapperStyle ?? {});
  const toastContentContainer = useStyle(
    styleOverridesTokens?.contentContainerStyle ?? {},
  );
  const toastText1 = useStyle(styleOverridesTokens?.text1Style ?? {});
  const toastText2 = useStyle(styleOverridesTokens?.text2Style ?? {});

  const leading =
    renderLeadingIcon ??
    (() => {
      if (iconProps) {
        const { width = 18, height = 18, ...iconRest } = iconProps;
        return <Icon {...iconRest} width={width} height={height} />;
      }
      if (imageProps?.source) {
        const { width = 48, height = 48, borderRadius } = imageProps;
        return (
          <Image
            source={imageProps.source}
            width={width}
            height={height}
            contentFit="cover"
            style={borderRadius ? { borderRadius } : undefined}
          />
        );
      }
      return null;
    });

  const trailing =
    renderTrailingIcon ??
    (() => {
      if (trailingIconProps) {
        const { width = 18, height = 18, ...iconRest } = trailingIconProps;
        return <PressableIcon {...iconRest} width={width} height={height} />;
      }
      return null;
    });

  return (
    <BaseToast
      {...rest}
      renderLeadingIcon={leading}
      style={[
        { ...baseStyle, ...successStyle },
        toastWrapper,
        styleOverrides?.wrapperStyle,
      ]}
      contentContainerStyle={[
        containerStyle,
        toastContentContainer,
        styleOverrides?.contentContainerStyle,
      ]}
      text1Style={[
        { ...textStyle, fontWeight: '600' },
        toastText1,
        styleOverrides?.text1Style,
      ]}
      text2Style={[textStyle, toastText2, styleOverrides?.text2Style]}
      renderTrailingIcon={trailing}
      text2NumberOfLines={10}
    />
  );
}

export default memo(CustomToast);
